import { motion, useMotionValue, useTransform } from "framer-motion";
import { LogoMark } from "./Logo";
import { useBrand } from "../../context/brand";

const ease = [0.76, 0, 0.24, 1];

export const Splash = ({ onSkip }) => {
  const LINES = useBrand().splash;
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotY = useTransform(x, [-1, 1], [-18, 18]);
  const rotX = useTransform(y, [-1, 1], [14, -14]);
  const move = (e) => {
    const p = e.touches ? e.touches[0] : e;
    x.set((p.clientX / window.innerWidth) * 2 - 1);
    y.set((p.clientY / window.innerHeight) * 2 - 1);
  };

  return (
    <motion.div
      data-testid="splash-screen"
      className="lz-splash"
      onClick={onSkip}
      onPointerMove={move}
      onTouchMove={move}
      exit={{ y: "-100%", transition: { duration: 0.8, ease } }}
    >
      <div className="lz-grain" />
      <motion.div style={{ rotateX: rotX, rotateY: rotY, transformPerspective: 600 }}
        initial={{ scale: 0.4, opacity: 0, rotate: -90 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
        <LogoMark size={130} full className="lz-splash-logo" />
      </motion.div>
      <h1 className="lz-splash-title">
        {LINES.map((l, i) => (
          <span key={l} className="lz-mask">
            <motion.span className={i === 2 ? "lz-accent" : ""} style={{ display: "inline-block" }}
              initial={{ y: "110%" }} animate={{ y: "0%" }}
              transition={{ duration: 0.85, delay: 0.25 + i * 0.12, ease }}>
              {l}
            </motion.span>
          </span>
        ))}
      </h1>
      <motion.p className="lz-splash-sub" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9 }}>
        Conectando você ao atendimento...
      </motion.p>
      <motion.div className="lz-splash-bar" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 2, ease: "linear" }} />
    </motion.div>
  );
};
